var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [
            _c(
              "div",
              {
                staticClass: "caption-container",
              },
              [
                _c(
                  "div",
                  [
                    _c("studip-icon", {
                      attrs: {
                        shape: "folder-public-full",
                        size: 30,
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.caption))]),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [
                _c("label", [
                  _c("input", {
                    ref: "checkAll",
                    attrs: {
                      type: "checkbox",
                    },
                    domProps: {
                      checked: _vm.allChecked,
                    },
                    on: {
                      change: _vm.onCheckedAllChange,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "sr-only",
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Alle Bilder auswählen")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Format")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Größe")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$gettext("Abmessungen")))]),
            ]),
          ]),
          _vm._v(" "),
          _vm.paged.length
            ? _c(
                "tbody",
                _vm._l(_vm.paged, function (stockImage) {
                  return _c("ImagesListItem", {
                    key: stockImage.id,
                    attrs: {
                      "stock-image": stockImage,
                      "is-checked": _vm.checkedImages.includes(stockImage.id),
                    },
                    on: {
                      checked: function checked($event) {
                        return _vm.$emit("checked", stockImage)
                      },
                      search: function search(query) {
                        return _vm.$emit("search", query)
                      },
                      select: function select($event) {
                        return _vm.$emit("select", stockImage)
                      },
                    },
                  })
                }),
                1
              )
            : _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      attrs: {
                        colspan: "5",
                      },
                    },
                    [
                      _vm.query.length
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "Zu diesem Suchbegriff konnten keine Bilder gefunden werden."
                                )
                              )
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "Es konnten keine Bilder gefunden werden."
                                )
                              )
                            ),
                          ]),
                    ]
                  ),
                ]),
              ]),
          _vm._v(" "),
          _vm.paged.length
            ? _c("tfoot", [
                _c("tr", [
                  _c(
                    "td",
                    {
                      attrs: {
                        colspan: "5",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          attrs: {
                            type: "button",
                            disabled: !_vm.checkedImages.length,
                          },
                          on: {
                            click: function click($event) {
                              _vm.showConfirmDelete = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$gettext("Löschen")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showConfirmDelete
        ? _c("studip-dialog", {
            attrs: {
              title: this.$ngettext(
                "Ausgewähltes Bild unwideruflich löschen?",
                "Ausgewählte Bilder unwideruflich löschen?",
                _vm.checkedImages.length
              ),
              question: _vm.$ngettext(
                "Möchten Sie das ausgewählte Bild wirklich löschen?",
                "Möchten Sie die ausgewählten Bilder wirklich löschen?",
                _vm.checkedImages.length
              ),
              height: "200",
              width: "450",
            },
            on: {
              confirm: _vm.onDelete,
              close: function close($event) {
                _vm.showConfirmDelete = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }